import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./brink_api_server.js";
//#region src/brink_api_server_helper.ts
var brink_api_server_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(apiServer) {
	switch (apiServer) {
		case 1: return "Sandbox";
		case 101: return "API";
		case 2: return "API 2";
		case 3: return "API 3";
		case 4: return "API 4";
		case 5: return "API 5";
		case 6: return "API 6";
		case 7: return "API 7";
		case 8: return "API 8";
		case 9: return "API 9";
		case 10: return "API 10";
		case 11: return "API 11";
		case 12: return "API 12";
		case 14: return "API 14";
		case 15: return "API 15";
		case 19: return "API 19";
		case 20: return "API 20";
		case 21: return "API 21";
		case 22: return "API 22";
		case 23: return "API 23";
		case 24: return "API 24";
		case 25: return "API 25";
		case 26: return "API 26";
		case 27: return "API 27";
		case 28: return "API 28";
		case 29: return "API 29";
		case 30: return "API 30";
		case 31: return "API 31";
		case 32: return "API 32";
		case 33: return "API 33";
		case 34: return "API 34";
		case 35: return "API 35";
		case 36: return "API 36";
		case 37: return "API 37";
		case 38: return "API 38";
		case 39: return "API 39";
		case 40: return "API 40";
		case 41: return "API 41";
		case 42: return "API 42";
		case 43: return "API 43";
		case 44: return "API 44";
		case 45: return "API 45";
		case 46: return "API 46";
		case 47: return "API 47";
		case 48: return "API 48";
		case 49: return "API 49";
		case 50: return "API 50";
		case 10001: return "API Sales";
		case 10002: return "Admin Channel";
		case 10003: return "Zaxbys UAT Lab";
		case 10004: return "API Early Exposure";
	}
}
//#endregion
export { brink_api_server_helper_exports, name };

//# sourceMappingURL=brink_api_server_helper.js.map